// extracted by mini-css-extract-plugin
export default {"col_wbf":"index_col_wbf_MH4PW","bg_poz":"index_bg_poz_3t2Yx","col_w960":"index_col_w960_0sAUy"};